export default {"src":"/_next/static/media/blueberries.f37b2dc5.svg","height":30,"width":60,"blurWidth":0,"blurHeight":0};